/**
 * @file フッターコンポーネント。SNCCの場合はSony Network Communications Connect社名、
 *        FVNOの場合はcompanyNameを表示。
 */
import { useRecoilValue } from 'recoil';
import { Constants } from '@/utils/constants';
import { providerInfoState } from '@/states/providerInfoState';

const Footer = () => {
  const providerInfo = useRecoilValue(providerInfoState);

  return (
    <footer id='footer'>
      <p className='copyright'>
        &copy;
        {providerInfo.providerId === Constants.ProviderId.SNCC
          ? '2024 Sony Network Communications Connect Inc.'
          : providerInfo.companyName}
      </p>
    </footer>
  );
};

export default Footer;
